var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeptune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "nep",
    cx: "35%",
    cy: "30%",
    r: "85%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6fb1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a6ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#12308f"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 96,
    fill: "url(#nep)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#a9ccff",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 70 q20 -8 40 -4",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 92 q26 -8 52 -2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 120 q22 -6 44 -4",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 140 q24 -6 48 -2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 160 q20 -6 40 -2",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeptune);
export default __webpack_public_path__ + "static/media/neptune.c4bc8fd6aa3bf059c1448db781d6b2f2.svg";
export { ForwardRef as ReactComponent };